import C from '@/utils/rule/constant'

class BaseCalculator {
    /**
     * 身高
     * @type {number}
     */
    height = 0;
    /**
     * 体重
     * @type {number}
     */
    weight = 0;
    /**
     * 穿衣偏好
     * @type {string}
     */
    preference = '1';
    /**
     * 默认体型
     * @type {string}
     */
    default_somatotype = 'A';
    /**
     * 自选体型
     * @type {string}
     */
    custom_somatotype = false;
    /**
     * BMI系数
     * @type {number}
     */
    bmi = 0;
    /**
     *净体参数数据
     * @type {{}}
     */
    net_size = {}
    /**
     * 体态特征数据
     * @type {{}}
     */
    body_size = {}

    setHW(height, weight) {
        this.height = height
        this.weight = weight
        this.bmi = weight * 10000 / (height * height)
        if(this.bmi <= 18.5) {
            this.setDefaultSomatotype(C.SOMATOTYPE_Y)
        } else if(this.bmi <= 23) {
            this.setDefaultSomatotype(C.SOMATOTYPE_A)
        } else if(this.bmi <= 26) {
            this.setDefaultSomatotype(C.SOMATOTYPE_B)
        } else if(this.bmi <= 29) {
            this.setDefaultSomatotype(C.SOMATOTYPE_C)
        } else {
            this.setDefaultSomatotype(C.SOMATOTYPE_D)
        }
    }


    /**
     * 设置体型
     * @param somatotype
     */
    setDefaultSomatotype(somatotype) {
        this.default_somatotype = somatotype
    }

    getDefaultSomatotype() {
        return this.default_somatotype
    }

    setCustomSomatotype(somatotype) {
        this.custom_somatotype = somatotype
    }

    /**
     * 设置净体参数数据
     * @param size
     */
    setNetSize(size) {
        this.net_size = size
    }


    /**
     * 设置体态特征数据
     * @param size
     */
    setBodySize(size) {
        this.body_size = size
    }
}

export default BaseCalculator
